export const getInst = async ({ commit, dispatch }, payload) => {
  let { data } = await axios.post("/course-insts/get", {
    course_id: payload.id
  });
  if (data.instructors.length > 0) {
    data.instructors.forEach(e => {
      dispatch("getInstractor", e.user_id);
    });
  }
};
export const getAllAdjustmentTrue = async (context, payload) => {
  try {
    let { data } = await axios.post("/adjustment/get-all", {
      page_num: payload.p,
      paid: true
    });
    // context.commit('setLengthList', { key: 'AllAdjustmentTrueLengths', lengths: data.adjusts.length })
    if (data.state != 200) {
      return;
    }
    if (data.adjusts.length > 0) {
      context.commit("setList", {
        key: "AllAdjustmentTrue",
        list: data.adjusts
      });
    }
  } catch (error) {
    console.log(error);
  }
};
export const getMyHistory = async (context, payload) => {
  try {
    let { data } = await axios.post("/adjustment/get-user-money-history");
    if (data.state != 200) {
      return;
    }
    context.commit("setList", { key: "myHistory", list: data.history });
  } catch (error) {
    console.log(error);
  }
};
export const getLstMyTransaction = async (context, payload) => {
  try {
    let { data } = await axios.post("/bill/get-my-bill-reuslt-all", {
      page_num: payload.p
    });
    context.commit("setLengthList", {
      key: "listMyTransactionLengthList",
      lengths: data.result.length
    });
    if (data.state != 200) {
      return;
    }
    if (data.result.length > 0) {
      context.commit("setList", {
        key: "listMyTransaction",
        list: data.result
      });
    }
  } catch (error) {
    console.log(error);
  }
};
export const getLstAllTransaction = async (context, payload) => {
  try {
    let { data } = await axios.post("/bill/get-all-bill-reuslt", {
      page_num: payload.p
    });
    if (data.state != 200) {
      return;
    }
    context.commit("setLengthList", {
      key: "listAllTransactionLengthList",
      lengths: data.result.length
    });
    if (data.result.length > 0) {
      context.commit("setList", {
        key: "listAllTransaction",
        list: data.result
      });
    }
  } catch (error) {
    console.log(error);
  }
};
export const getMyEarnList = async (context, payload) => {
  try {
    let { data } = await axios.post("/earn/get-my-earn-list", {
      page_num: payload.p
    });
    if (data.state != 200) {
      return;
    }
    context.commit("setLengthList", {
      key: "myEarnListlengths",
      lengths: data.earn_list.length
    });
    if (data.earn_list.length > 0) {
      context.commit("setList", { key: "myEarnList", list: data.earn_list });
    }
  } catch (error) {
    console.log(error);
  }
};
export const getAllEarnList = async (context, payload) => {
  try {
    let { data } = await axios.post("/earn/get-all-earn-list", {
      page_num: payload.p
    });
    if (data.state != 200) {
      return;
    }
    context.commit("setLengthList", {
      key: "allEarnListlengths",
      lengths: data.earn_list.length
    });
    if (data.earn_list.length > 0) {
      context.commit("setList", { key: "allEarnList", list: data.earn_list });
    }
  } catch (error) {
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/accounting/actions.js